export interface FaqItem {
  q: string;
  a: string;
  group: string;
}

export const faqGroups = ["内容来源", "爆料投稿", "阅读与转载", "平台立场"];

export const faqItems: FaqItem[] = [
  {
    group: "内容来源",
    q: "每日新瓜网的内容是从哪里来的？",
    a: "我们的内容主要分为三类：一是编辑部对公开信息的整理与盘点，二是来自读者的实名或匿名投稿，三是对行业公开采访、节目物料进行的理性解读。所有内容都力求标注可查证的时间线与事实，避免主观臆断。",
  },
  {
    group: "内容来源",
    q: "报道涉及的人物信息真实吗？会不会对号入座？",
    a: "本站文章以讨论行业现象与公共话题为主，很多人物与事件采用化名或隐去可识别信息处理。我们始终坚持「对事不对人」，也请读者理性看待，不要将文中内容与现实中任何具体个人强行对应或进行人身攻击。",
  },
  {
    group: "内容来源",
    q: "平台会核实每一条投稿的真实性吗？",
    a: "我们会尽最大努力对投稿进行交叉验证，包括时间线、多方说法与公开佐证。但由于信息有限，无法保证每条投稿都百分之百准确。对于存在争议的稿件，我们会在标题和正文中明确标注「待核实」，请读者以批判眼光看待。",
  },
  {
    group: "爆料投稿",
    q: "我想投稿爆料，需要注意什么？",
    a: "欢迎通过页面的「投稿爆料」入口向我们反馈线索。建议提供尽可能完整的信息，包括事件经过、时间地点、可公开的证据或链接。出于保护考虑，我们支持匿名投稿，并在发布前与你进一步确认细节。",
  },
  {
    group: "爆料投稿",
    q: "投稿会不会侵犯他人隐私或引发法律风险？",
    a: "平台严禁发布虚假信息、人身诽谤、偷拍私密内容等违法违规投稿。编辑部会对涉及隐私的稿件做脱敏处理，涉及重大名誉或法律风险的线索，我们会建议投稿人通过正规渠道处理，而非单纯放大传播。",
  },
  {
    group: "阅读与转载",
    q: "文章可以转载或引用吗？",
    a: "欢迎在注明来源「每日新瓜网」的前提下进行有限度的转载与引用。如需大篇幅转载或商用，请先通过页面底部邮箱与我们联系获得授权。未注明来源的搬运将视为侵权。",
  },
  {
    group: "阅读与转载",
    q: "为什么有的文章会标注「待核实」？",
    a: "娱乐行业的消息来源复杂，真相往往需要时间沉淀。对于缺乏确凿证据或存在不同说法的内容，我们宁可放慢更新，也要在标题与正文中明确告知读者信息尚待确认，这是一种对事实和读者的基本负责。",
  },
  {
    group: "平台立场",
    q: "每日新瓜网的平台立场是什么？",
    a: "我们倡导「理性吃瓜」。平台不鼓励网暴、不传播仇恨、不消费苦难，而是希望通过对娱乐工业现象的观察，帮读者看清行业运行逻辑与人设背后的规律。我们关注事件，更关注事件折射出的行业问题。",
  },
];